import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";

interface RujukanMasukOnline {
  status: 1 | 0
  data: undefined | {
    metaData: {
      code: string
      message: string
    }
    response: {
      asalFaskes: string
      rujukan: {
        noKunjungan: string
        tglKunjungan: string
        provPerujuk: {
          kode: string
          nama: string
        }
        peserta: {
          noKartu: string
          nik: string
          nama: string
          pisa: string
          sex: string
          mr: {
            noMR: string
            noTelepon: string
          }
          tglLahir: string
          tglCetakKartu: string
          tglTAT: string
          tglTMT: string
          statusPeserta: {
            kode: string
            keterangan: string
          }
          provUmum: {
            kdProvider: string
            nmProvider: string
          }
          jenisPeserta: {
            kode: string
            keterangan: string
          }
          hakKelas: {
            kode: string
            keterangan: string
          }
          umur: {
            umurSekarang: string
            umurSaatPelayanan: string
          }
          informasi: {
            dinsos: string
            prolanisPRB: string
            noSKTM: string
            eSEP: string
          }
          cob: {
            noAsuransi: string
            nmAsuransi: string
            tglTMT: string
            tglTAT: string
          }
        }
        diagnosa: {
          kode: string
          nama: string
        }
        keluhan: string
        poliRujukan: {
          kode: string
          nama: string
        }
        pelayanan: {
          kode: string
          nama: string
        }
      }
    }
  }
  message: undefined | string
}

async function getByNoka(type: string | number, nomor: string) {
  const response = await http
    .getData(`/rujukan-masuk?jenis=${type}&nokartu=${nomor}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getByNoRujukan(type: string | number, nomor: string) {
  const response = await http
    .getData(`/rujukan-masuk?jenis=${type}&norujukan=${nomor}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function getByNoRujukanOnline(nomor: string): Promise<RujukanMasukOnline> {
  const response = await http
    .getData(`/rujukan/${nomor}/get-online`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function create(data: unknown) {
  const response = await http.postData(`/rujukan-keluar`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function update(data: unknown) {
  const response = await http.putData(`/rujukan-keluar`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function remove(data: unknown) {
  const response = await http.deleteData(`/rujukan-keluar`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function getRujukanKeluarByNoRujukan(nomor: string) {
  const response = await http
    .getData(`/rujukan-keluar/${nomor}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

function print(noRujukan) {
  window.open(`${http.getAPI()}/rujukan-keluar/${noRujukan}/cetak`, "_blank");
}

export default {
  getByNoka,
  getByNoRujukan,
  getByNoRujukanOnline,
  getRujukanKeluarByNoRujukan,
  create,
  update,
  remove,
  print
};
